export default "__VITE_ASSET__FCkwY76Y__"